/* site/siteLangContext.js — the site's chosen language, shared between the layout (which owns the
 * state and runs the applier) and the chrome (which renders the EN · IT · DE · FR buttons).
 * Its own module so SiteLayout and SiteChrome can both import it without a cycle. */
import { createContext, useContext } from "react";

export const SiteLangContext = createContext({ lang: "en", setLang: () => {} });
export const useSiteLang = () => useContext(SiteLangContext);
